import "./index.css";
import pic1 from "../../assets/images/directors/director_pic1.png";
import pic2 from "../../assets/images/directors/director_pic2.png";

const directors = [
  {
    name: "MUHAMMAD HAMMAD ARSHAD",
    position: "Director / Chief Executive Officer",
    image: pic1,
    bio: "Muhammad Hammad Arshad is CIA and MBA have attained excellent exposure of Regulatory Developments / Compliance assurance in Stock Market over 11 years and have the experience of implementation of SEC Ordinance, SEC, Rules and Capital Market Intermediaries Regulations. Mr. Mian has the vast expertise in brokerage business management, mutual funds management, corporate matters and statutory compliance. In-depth knowledge and vast understanding of Corporate Laws, Tax Laws and Accounting Standards along with the practical experience of working on key positions has made him top ranking professional. Enthusiasm & drive coupled with vast experience is the reason to be an energetic & pro-active professional. Mr. Hammad has also participated in many international investment conferences and represented Pakistan in UAE. Before joining OSPL in March, 2022, He had served in the DMCC (Dubai Multi Commodities Centre) UAE on the key positions.",
  },
  {
    name: "MRS. JAMNA DEVI REENA KUMARI",
    position: "Director / Company Secretary",
    image: pic2,
    bio: "Mrs. Jamna Devi Reena Kumari is MBA in finance. Blended with entrepreneurial mind and convinced with the capital markets of Pakistan she founded Orbit Securities Limited in 2022. Her vast experience of trading in the capital markets of Pakistan laid a strong foundation for Orbit Securities Private Limited. She possesses unique insight into the working of stock market with major exposure of capital market of Pakistan. Over the years the clients in capital market have taken a lot of benefit from her expertise in capital market operations that includes dealing in equities, sales and marketing strategies, financial advisory and customer relationships. Before joining OSPL, She had served in the many capital market companies and listed company on the key positions.",
  },
];

export default function BoardOfDirectors() {
  return (
    <div className="bod-page">
      <div className="bod-inner">
        <div className="bod-eyebrow"><span className="bod-dash" />OUR LEADERSHIP<span className="bod-dash" /></div>
        <h1 className="bod-title">BOARD OF <span>DIRECTORS</span></h1>
        <span className="bod-title-underline" />
        <p className="bod-desc">
          Our Board of Directors brings together a wealth of experience and
          expertise in the financial services industry. Their leadership and
          vision guide our company towards continued success and growth.
        </p>

        <div className="bod-grid">
          {directors.map((director, index) => (
            <div key={index} className="bod-card">
              <div className="bod-img-frame">
                <img src={director.image} alt={director.name} className="bod-img" />
              </div>
              <div className="bod-info">
                <h2 className="bod-name">{director.name}</h2>
                <div className="bod-position">{director.position}</div>
                <span className="bod-card-underline" />
                <p className="bod-bio">{director.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
